import { render, staticRenderFns } from "./UpdateDataIsolationLevel.vue?vue&type=template&id=79bee768&scoped=true&"
import script from "./UpdateDataIsolationLevel.vue?vue&type=script&lang=js&"
export * from "./UpdateDataIsolationLevel.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDataIsolationLevel.vue?vue&type=style&index=0&id=79bee768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bee768",
  null
  
)

export default component.exports